import {
  USE_CASE,
  USER_ROLE,
} from '@trustero/trustero-api-web/lib/account/account_pb'
import {
  getCookieValue,
  setCookieIfExists,
  removeCookieIfExists,
} from 'src/Utils/globalHelpers'

export enum LoginProviders {
  GOOGLE = 'Google',
  AUTH0 = 'Auth0', //Auth0 was acquired by Okta
  OKTA = 'Okta',
  ONELOGIN = 'OneLogin',
  MICROSOFT = 'Microsoft',
  ENTRA = 'Entra',
  PINGONE = 'PingOne',
  ENTRAIDSSO = 'Enterprise SSO',
}

export type AuthorizationComponentProps = {
  login: ({
    accessToken,
    accountId,
    email,
    useCase,
  }: {
    accessToken: string
    accountId?: string
    email?: string
    redirectUrl: string
    useCase: USE_CASE
    role: USER_ROLE
  }) => void
  setErrorMsg?: React.Dispatch<React.SetStateAction<string>>
  setIsRedirecting?: React.Dispatch<React.SetStateAction<boolean>>
}

const LAST_LOGIN_COOKIE = 'lastlogin'

export const getLastLogin = (): LoginProviders | null => {
  const stored = getCookieValue(LAST_LOGIN_COOKIE)
  if (stored === null) {
    return null
  }
  const validProviders = Object.values(LoginProviders)
  if (validProviders.includes(stored as LoginProviders)) {
    return stored as LoginProviders
  }
  return null
}

export const setLastLogin = (lastLogin: LoginProviders): void => {
  setCookieIfExists(LAST_LOGIN_COOKIE, lastLogin)
}

export const clearLastLogin = (): void => {
  removeCookieIfExists(LAST_LOGIN_COOKIE)
}
